import {
  FiHome,
  FiUsers,
  FiUserCheck,
  FiCreditCard,
  FiActivity,
  FiDollarSign,
  FiPlayCircle,
  FiBriefcase,
  FiLayers,
  FiSliders,
  FiLifeBuoy,
} from 'react-icons/fi'

export const SUPPORT_EMAIL = 'support@loyalideas.com'

export const navEntries = [
  { key: 'overview', label: 'Overview', to: '/', icon: FiHome, match: ['/'], exact: true },
  { key: 'customers', label: 'Merchants', to: '/customers', icon: FiUsers, match: ['/customers'] },
  { key: 'enterprise', label: 'Enterprise Accounts', to: '/enterprise-accounts', icon: FiLayers, match: ['/enterprise-accounts'] },
  { key: 'team', label: 'Team', to: '/team', icon: FiUserCheck, match: ['/team'] },
  { key: 'passes', label: 'NFC Passes', to: '/nfs-pass', icon: FiCreditCard, match: ['/nfs-pass'] },
  { key: 'demo', label: 'Loyalty Demo', to: '/loyalty-demo', icon: FiActivity, match: ['/loyalty-demo'] },
  { key: 'plans', label: 'Plans', to: '/plans', icon: FiDollarSign, match: ['/plans'] },
  { key: 'videos', label: 'Videos', to: '/videos', icon: FiPlayCircle, match: ['/videos'] },
  { key: 'business', label: 'Business Cards', to: '/business-cards', icon: FiBriefcase, match: ['/business-cards'] },
  { key: 'settings', label: 'Settings', to: '/settings', icon: FiSliders, match: ['/settings', '/account'] },
  { key: 'support', label: 'Support', href: `mailto:${SUPPORT_EMAIL}`, icon: FiLifeBuoy, match: [], pinned: 'bottom' },
]

const matchesPrefix = (pathname, prefix, exact) =>
  exact ? pathname === prefix : pathname === prefix || pathname.startsWith(`${prefix}/`)

export const getActiveEntry = (pathname) =>
  navEntries.find((entry) => entry.match.some((prefix) => matchesPrefix(pathname, prefix, entry.exact)))
